import React from 'react';
import { Marker, InfoBox } from '@react-google-maps/api';
import { getUniqueStopMarkers, getSequence } from '../helper';
import { CustomPolyLine } from '../MarkersAndPolyLine';
import {
  ACTUAL_VS_PLANNED_PROPERTY,
  PATH_PROPERTY,
  PATH_TYPE,
  selectedStopIconSvg,
  stopIconSvg,
  smallChequeredFlag,
} from '../constants';

/* eslint-disable no-undef */

function MapViewWithMarkerAndPath(props) {
  const { markers, paths, color, strokeOpacity, icons, onMarkerClicked, isActual } = props;
  const locationArray = paths.map((r) => r.location);
  const uniqStopMarkers = getUniqueStopMarkers(markers);
  console.log({ uniqStopMarkers });
  return (
    <>
      <CustomPolyLine
        locations={locationArray}
        strokeColor={color}
        strokeWeight={PATH_PROPERTY[PATH_TYPE.RESOLVED].strokeWeight}
        strokeOpacity={strokeOpacity}
        icons={icons}
      />
      {uniqStopMarkers.map((marker) => (
        <Marker
          icon={{
            url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
              marker.stopId === props.selectedStopId ? selectedStopIconSvg() : stopIconSvg()
            )}`,
            anchor: new google.maps.Point(20, 40),
            strokeWeight: 8,
          }}
          position={marker.location}
          onClick={() => {
            onMarkerClicked(marker);
          }}
          id={marker.stopId}
          key={marker.stopId}
          noRedraw
        >
          <InfoBox
            position={marker.location}
            options={{ closeBoxURL: '', enableEventPropagation: true, pixelOffset: new google.maps.Size(0, -50) }}
          >
            <div
              style={{
                height: '20px',
                minWidth: '30px',
                margin: '3px 15px 10px 6px',
                padding: '2px 10px 2px 2px',
                borderRadius: '20px',
                border: `solid 1px ${isActual ? '#009574' : '#114477'}`,
                backgroundColor: isActual ? '#e0fffc' : '#c8e3fd',
                top: '16px',
                left: '25px',
                display: 'flex',
              }}
            >
              <div
                style={{
                  background: isActual ? '#009574' : '#114477',
                  width: '15px',
                  borderRadius: '50%',
                  margin: '0px 2px 0px 0px',
                  padding: '2px 4px 1px',
                }}
              >
                <img
                  src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(smallChequeredFlag)}`}
                  height="10px"
                  width="8px"
                />
              </div>
              <div>{getSequence(marker.sequence)}</div>
            </div>
          </InfoBox>
        </Marker>
      ))}
    </>
  );
}

function ActualMapView(props) {
  const {
    routeData: { stops = [], locations = [] },
    onStopClick,
    selectedStopId,
  } = props;
  return (
    <MapViewWithMarkerAndPath
      {...ACTUAL_VS_PLANNED_PROPERTY.ACTUAL}
      onMarkerClicked={onStopClick}
      markers={stops}
      paths={locations}
      selectedStopId={selectedStopId}
      isActual
    />
  );
}

function PlannedMapView(props) {
  const {
    routeData: { stops: plannedStops = [] },
    onStopClick,
    selectedStopId,
  } = props;
  return (
    <MapViewWithMarkerAndPath
      {...ACTUAL_VS_PLANNED_PROPERTY.PLANNED}
      onMarkerClicked={onStopClick}
      markers={plannedStops}
      paths={plannedStops}
      selectedStopId={selectedStopId}
    />
  );
}

export default function ActualVsPlannedMapView(props) {
  const {
    routeData: { actual, planned },
    onStopClick,
    selectedStopId,
  } = props;
  return (
    <>
      {actual && <ActualMapView routeData={actual} onStopClick={onStopClick} selectedStopId={selectedStopId} />}
      {planned && <PlannedMapView routeData={planned} onStopClick={onStopClick} selectedStopId={selectedStopId} />}
    </>
  );
}
